import {MouseEventHandler} from 'react';
import TextButton from '../../ui/button/TextButton';

interface IProps {
  disabled?: boolean;
  isWhiteBg: boolean;
  text: string;
  onClick?: MouseEventHandler;
  className?: string;
}

export default function EventButtonV4({
  disabled,
  isWhiteBg,
  text,
  onClick,
  className,
}: IProps) {
  return (
    <TextButton
      disabled={disabled}
      className={cn('rounded-40 py-8 px-16 leading-16', className, {
        'bg-white': isWhiteBg,
        'bg-black': !isWhiteBg,
        'opacity-30': disabled,
      })}
      textClassName={cn('tracking-[-0.4px] !whitespace-nowrap', {
        's13-bold-black': isWhiteBg,
        's13-bold-white': !isWhiteBg,
      })}
      onClick={onClick}
      data-testid="event-button"
    >
      {text}
    </TextButton>
  );
}
